export class LogisticAddress {
  constructor(
    public addressLine1?: string,
    public addressLine2?: string,
    public city?: string,
    public state?: string,
    public countryCode?: string,
    public postalCode?: string,
    public countryName?: string,
    public urbanizationCode?: string) { }

}
